export function formatCurrency(val) {
    let amount = val ? val : 0;
    amount = parseFloat(amount);
    amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace('$', '');
    return amount;
}       